import documentDetails from "./documentDetails"
export default documentDetails;
